/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Disabled_SuccessInputs */



/**
* | output |
* | --- |
* | "SCIM provisioning disabled successfully" |
*
* @param {Scim_Disabled_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_disabled_success = /** @type {((inputs?: Scim_Disabled_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Disabled_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("SCIM-Bereitstellung erfolgreich deaktiviert")
	return /** @type {LocalizedString} */ ("SCIM provisioning disabled successfully")
});